/***
 *
 *   LOADER
 *   Infinite spinning animation for loading states
 *
 **********/

import "./loader.css";

type LoaderProps = {
  className?: string;
  fullScreen?: boolean;
};

export function Loader(props: LoaderProps) {
  return (
    <div
      className={`${props.fullScreen ? "fixed inset-0" : ""
      } flex items-center justify-center w-20`}
    >
      <span className="loading loading-spinner pointer-events-none inline-block aspect-square w-6"></span>
    </div>
  );
}
